import { BindAll } from 'lodash-decorators'

@BindAll()
export class MyAccountBishanController {
  public onReset(): void {}
}
